import React, { FC } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Organization } from 'models/organization';
import FormattedAddress from 'components/shared/address/formatted-address.component';

type ContactBoxProps = {
    organization: Organization;
    title: string;
};

const ContactBox: FC<ContactBoxProps> = ({ organization, title }: ContactBoxProps) => {
    return (
        <Paper variant="outlined">
            <Box p={1}>
                <Typography variant="subtitle2">{title}:</Typography>
                <Box>{organization.name}</Box>
                <Box>
                    <FormattedAddress address={organization.contact.address} />
                </Box>
            </Box>
        </Paper>
    );
};

export default ContactBox;
